import { useHistory, useLocation } from 'react-router-dom';

export const SOLAR_INSPECTOR_DIALOG_HASHES = [
  '#solar-array-rules',
  '#solar-credit-policy',
];

/** Keep inspector editors in browser history, including Back / Forward. */
export const useInspectorDialog = (hash: string) => {
  const history = useHistory();
  const location = useLocation();
  const isOpen = location.hash === hash;
  const toggle = () =>
    history.push({
      pathname: location.pathname,
      search: location.search,
      hash: isOpen ? '' : hash,
      state: location.state,
    });
  return [isOpen, toggle] as const;
};
